import { contratoCuotaApi } from '../../utils/api';
import { getListDataAction } from '../../utils/DataAction';

export const getAll = getListDataAction({
  dataName: 'CONTRATO_CUOTA_ESTADO',
  api: contratoCuotaApi,
  relUrl: 'getAllEstados',
});
